import { SortState } from './types';

export const DataViewAtomFamilyKey = {
  MANAGE_PLANS: 'manage-plans',
  REPORTS_PLANS: 'reports-plans',
  REPORTS_PLAN_TEAM_MEMBERS: 'reports-plans-teammembers',
  REPORTS_PLANS_LICENSEE: 'reports-plans-licensee',
  LICENSEE_LOCATIONS: 'licensee-locations',
  MY_PLANS: 'my-plans',
  REPORTS_TEAM_MEMBERS: 'reports-team-members',
  REPORTS_TEAM_MEMBERS_SUMMARY: 'reports-team-members-summary',
  MANAGE_TEAM_MEMBERS: 'manage-team-members',
  BUILD_PLANS: 'build-plans',
  QUIZZES: 'manage-quizzes',
  BUILD_QUIZES: 'build-quizzes',
  CHOOSE_TEMPLATE: 'choose-template',
} as const;

export const dataViewSortDefaults: Partial<
  Record<
    (typeof DataViewAtomFamilyKey)[keyof typeof DataViewAtomFamilyKey],
    SortState<Record<string, unknown>>
  >
> = {
  [DataViewAtomFamilyKey.MANAGE_PLANS]: {
    key: 'createdDateTime',
    direction: 'desc',
  },
  [DataViewAtomFamilyKey.MY_PLANS]: {
    key: 'dueDate',
    direction: 'asc',
  },
  [DataViewAtomFamilyKey.REPORTS_TEAM_MEMBERS]: {
    key: 'displayName',
    direction: 'asc',
  },
  [DataViewAtomFamilyKey.MANAGE_TEAM_MEMBERS]: {
    key: 'displayName',
    direction: 'asc',
  },
  [DataViewAtomFamilyKey.QUIZZES]: {
    key: 'created',
    direction: 'desc',
  },
  [DataViewAtomFamilyKey.CHOOSE_TEMPLATE]: {
    key: 'created',
    direction: 'desc',
  },
  [DataViewAtomFamilyKey.REPORTS_TEAM_MEMBERS_SUMMARY]: {
    key: 'searchableName',
    direction: 'asc',
  },
  [DataViewAtomFamilyKey.REPORTS_PLANS_LICENSEE]: {
    key: 'createdDateTime',
    direction: 'desc',
  },
  [DataViewAtomFamilyKey.REPORTS_PLANS]: {
    key: 'createdDateTime',
    direction: 'desc',
  },

  [DataViewAtomFamilyKey.REPORTS_PLAN_TEAM_MEMBERS]: {
    key: 'displayName',
    direction: 'asc',
  },
};
